export { default as CourseraMetatags } from 'bundles/seo/components/CourseraMetatags';
export { default as SimpleCourseraMetatags } from 'bundles/seo/components/SimpleCourseraMetatags';
